import type { Page } from '../../app/feature';
import type { ApiPlayer } from '../../shared/types';
import { esc, inputValue, q } from '../../shared/dom';
import { t } from '../../shared/i18n';
import { dateTime, fmt } from '../../shared/format';
import { ApiError } from '../../shared/api/http';
import { toast } from '../../shared/ui/toast';
import { href } from '../../app/router';
import { playersApi } from './players.api';

let list: ApiPlayer[] = [];
let loaded = false;

/** Jogadores da casa conhecidos pela Rueda: busca, indicadores e acesso à ficha de cada um. */
export const players: Page = {
  id: 'jugadores',
  pattern: '/jugadores',
  roles: ['ADMIN', 'SUPPORT'],
  nav: { key: 'nav.players', icon: '👥', group: 'ops' },

  template: () => `
<div class="view-head">
  <div>
    <h2 data-i18n="pl.title">Jugadores</h2>
    <p data-i18n="pl.sub">Cada jugador entra aquí solo, en su primera acción que genera números. Abre la ficha para ver sus números, su actividad y emitir a mano si hace falta.</p>
  </div>
</div>

<div class="cols" style="margin-bottom:18px">
  <div class="kpi span-4" style="--accent:var(--orange)"><div class="k-label" data-i18n="kpi.players">Jugadores</div><div class="k-val tnum" id="pk-players">0</div><div class="k-sub" data-i18n="pl.kpiPlayers">con al menos un número</div></div>
  <div class="kpi span-4" style="--accent:var(--gold)"><div class="k-label" data-i18n="kpi.cartelas">Cartelas activas</div><div class="k-val tnum" id="pk-active">0</div><div class="k-sub" data-i18n="pl.kpiActive">participan en el próximo sorteo</div></div>
  <div class="kpi span-4" style="--accent:var(--green)"><div class="k-label" data-i18n="kpi.issued2">Cartelas emitidas</div><div class="k-val tnum" id="pk-total">0</div><div class="k-sub" data-i18n="pl.kpiTotal">en toda la historia</div></div>
</div>

<div class="panel-head">
  <h3 data-i18n="cart.table">Jugadores</h3>
  <div class="spacer"></div>
  <input type="text" id="pl-search" placeholder="Buscar por nombre o ID…" style="max-width:280px">
</div>
<div class="tw">
  <table id="tbl-players">
    <thead><tr>
      <th data-i18n="th.player">Jugador</th>
      <th data-i18n="cart.extId">ID en la casa</th>
      <th data-i18n="th.cartelas">Cartelas</th>
      <th data-i18n="pl.prizes">Premios ganados</th>
      <th data-i18n="pl.since">Desde</th>
      <th></th>
    </tr></thead>
    <tbody></tbody>
  </table>
</div>`,

  mount() {
    let timer: number | undefined;
    q<HTMLInputElement>('#pl-search').oninput = () => { window.clearTimeout(timer); timer = window.setTimeout(() => void load(), 250); };
  },

  render() {
    renderTable();
    if (!loaded) void Promise.all([load(), loadStats()]);
    else void loadStats();
  }
};

async function load(): Promise<void> {
  try { list = await playersApi.list(inputValue('#pl-search') || undefined); loaded = true; renderTable(); }
  catch (err) { toast(err instanceof ApiError ? err.message : t('auth.errGeneric')); }
}

async function loadStats(): Promise<void> {
  try {
    const s = await playersApi.stats();
    q('#pk-players').textContent = fmt(s.players);
    q('#pk-active').textContent = fmt(s.cartelasActive);
    q('#pk-total').textContent = fmt(s.cartelasTotal);
  } catch { /* indicadores são decorativos */ }
}

function renderTable(): void {
  q('#tbl-players tbody').innerHTML = list.map(p => `<tr>
    <td><a class="auth-link" href="${href('/jugadores/' + p.id)}"><b>${esc(p.name)}</b></a></td>
    <td class="tnum muted">${esc(p.externalId)}</td>
    <td class="tnum">${fmt(p.cartelasCount)}</td>
    <td class="tnum">${p.drawsCount ? `<span class="chip chip-green">${p.drawsCount}</span>` : '<span class="muted">—</span>'}</td>
    <td class="muted tnum" style="font-size:12px">${dateTime(Date.parse(p.createdAt))}</td>
    <td style="text-align:right"><a class="btn btn-sm" href="${href('/jugadores/' + p.id)}">${esc(t('pl.open'))}</a></td>
  </tr>`).join('') || `<tr><td colspan="6" class="empty">${loaded ? t('pl.none') : '…'}</td></tr>`;
}
